import React from 'react'
import { useAtom } from 'jotai'
import { Button, Box } from '@mui/material'
import ZoomInIcon from '@mui/icons-material/ZoomIn'
import ZoomOutIcon from '@mui/icons-material/ZoomOut'
import TextDecreaseIcon from '@mui/icons-material/TextDecrease'
import TextIncreaseIcon from '@mui/icons-material/TextIncrease'
import ButtonGroup from '@mui/material/ButtonGroup'
import { pictoSizeAtom, textSizeAtom } from 'atoms'

const PictoControls = ({ color = 'inherit' }) => {
  const [pictoSize, setPictoSize] = useAtom(pictoSizeAtom)
  const [textSize, setTextSize] = useAtom(textSizeAtom)
  const minSize = 60
  const maxSize = 300
  const minTextSize = 8
  const maxTextSize = 34

  // Handler for increasing size
  const handleIncrease = () => {
    if (pictoSize < maxSize) {
      setPictoSize(Number(pictoSize) + 5)
    }
  }

  // Handler for decreasing size
  const handleDecrease = () => {
    if (pictoSize > minSize) {
      setPictoSize(Number(pictoSize) - 5)
    }
  }

  // Handler for increasing size
  const handleTextIncrease = () => {
    if (textSize < maxTextSize) {
      setTextSize(Number(textSize) + 1)
    }
  }

  // Handler for decreasing size
  const handleTextDecrease = () => {
    if (textSize > minTextSize) {
      setTextSize(Number(textSize) - 1)
    }
  }
  return (
    <Box display="flex" gap={2} alignItems="center">
      {/* Decrease button */}
      <ButtonGroup variant="outlined" aria-label="Buttons for pictogram size">
        <Button
          onClick={handleDecrease}
          disabled={pictoSize <= minSize}
          color={color}
        >
          <ZoomOutIcon />
        </Button>

        {/* Increase button */}
        <Button
          onClick={handleIncrease}
          disabled={pictoSize >= maxSize}
          color={color}
        >
          <ZoomInIcon />
        </Button>
      </ButtonGroup>
      <ButtonGroup variant="outlined" aria-label="Buttons for pictogram size">
        <Button
          onClick={handleTextDecrease}
          disabled={textSize <= minTextSize}
          color={color}
        >
          <TextDecreaseIcon />
        </Button>

        {/* Increase button */}
        <Button
          onClick={handleTextIncrease}
          disabled={textSize >= maxTextSize}
          color={color}
        >
          <TextIncreaseIcon />
        </Button>
      </ButtonGroup>
    </Box>
  )
}

export default PictoControls
